import PropTypes from 'prop-types';
import React from 'react';
import SecondaryNav from '../../Common/containers/SecondaryNav';

function NFLNav({open, opener}) {
  const props = {
    open,
    opener,
    title: "NFL",
    links: [
      {href: "/nfl", text: "News", isIndex: true}
    ]
  };

  return (
    <SecondaryNav {...props}/>
  );
}

NFLNav.propTypes = {
  open: PropTypes.bool.isRequired,
  opener: PropTypes.func.isRequired
}

export default NFLNav



// WEBPACK FOOTER //
// ./modules/NFL/nav/NFLNav.js